import { DataProcessor } from "./DataProcessor";
import { ScoringService } from "../../services/ScoringService";

const questionMetadata = {
    excludedQuestions: {
        '0': ['2.3: Ar darbo atrankos metu Jūsų dabartinis  darbdavys sakė, kad stengiasi atsižvelgti į kandidačių/ -tų bei darbuotojų individualius poreikius (dėl kalbos, negalios, kita), teiravosi, ar Jūs tokių turite?'],
        '1': [
            '2.3: Ar darbo atrankos metu Jūsų dabartinis  darbdavys sakė, kad stengiasi atsižvelgti į kandidačių/ -tų bei darbuotojų individualius poreikius (dėl kalbos, negalios, kita), teiravosi, ar Jūs tokių turite?',
            '2.1.2: Ar Jūsų organizacija turi lygių galimybių įgyvendinimui skirtą veiksmų planą?',
            '2.1.9: Ar įmonė turi smurto ir priekabiavimo prevencijos politiką?'
        ],
        '2': ["2.1.3: Ar Jūsų organizacija priklauso bent vienai nacionalinei ar tarptautinei iniciatyvai, kuri skatina Į&Į arba verslo etiką (pabrėžiant lygias galimybes)?"]
    }
};

export class Calculator extends DataProcessor {
    constructor(nerodyti = {}) {
        super(nerodyti);
    }

    isQuestionExcludedForYear(questionName, year) {
        // Convert year to string since object keys are strings
        const yearStr = year.toString();

    
        return questionMetadata.excludedQuestions[yearStr]?.includes(questionName) || false;
    }

    vienoRezultatoAtsakymas(atsakymai = [], daliklis = 1, name = '') {
        if (!atsakymai.length || !name) {
            return [[name], 0];
        }

        const score = ScoringService.calculateAverageScore(atsakymai, name);
        return [[name], score];
    }

    imonesAtsakymai(atsakymai, klausimai, year) {
        const info = {};
        let totalScore = 0;
        let totalQuestions = 0;
        
        klausimai.forEach(klausimas => {
            const name = klausimas.name;
            
            // Skip excluded questions
            if (this.isQuestionExcludedForYear(name, year)) {
                info[name] = '-';
                return;
            }

            const [, score] = this.vienoRezultatoAtsakymas(atsakymai, 1, name);
            
            // Skip undefined or '-' scores
            if (score === undefined || score === '-' || score === 0) {
                info[name] = '-';
                return;
            }
            
            info[name] = score;
            totalScore += score;
            totalQuestions++;
        });

        // Add average score if we have any questions
        if (totalQuestions > 0) {
            info['average'] = totalScore / totalQuestions;
        } else {
            info['average'] = '-';
        }

        return info;
    }

    sudetAtsakymus(obj) {
        return ScoringService.calculateTotalScore(obj);
    }

    getCleanYear(year) {
        if (!year) {
            return new Date().getFullYear().toString();
        }
        // Convert relative years (0, 1, 2) to actual years
        const yearNum = parseInt(year);
        if (yearNum >= 0 && yearNum <= 9) { // If it's a small number, treat as relative year
            return (2023 + yearNum).toString(); // Start from 2023
        }
        return year.toString().replace(/[^0-9]/g, '');
    }

    klausimynas(tipai, year) {
        const puslapiai = this.puslapiaiIsTipu(tipai);
        const klausimynasAll = [];
        
        Object.values(puslapiai).forEach(lapas => {
            Object.values(lapas).forEach(klausimas => {

                if (!this.nerodyti?.questions?.includes(klausimas.name) && 
                    !this.isQuestionExcludedForYear(klausimas.name, year)) {
                    klausimynasAll.push(klausimas);
                }
            });
        });
        
        return klausimynasAll;
    }

    visuImoniuAtsakymaiIBendra(atsakymai) {
        const ats = {};
        atsakymai.forEach(imonesAts => {
            Object.entries(imonesAts).forEach(([key, value]) => {
                if (!isNaN(value) && typeof value === 'number') {
                    if (ats[key]) {
                        ats[key].push(value);
                    } else {
                        ats[key] = [value];
                    }
                }
            });
        });

        Object.keys(ats).forEach(key => {
            if (ats[key].length > 0) {
                ats[key] = ats[key].reduce((partialSum, a) => partialSum + a, 0) / ats[key].length;
            } else {
                ats[key] = '';
            }
        });

        return ats;
    }

    bendrasAtsakymas(atsakymai, tipai) {
        if (tipai.length === 1 && tipai[0].attributes.kasPildo === "Bendras įvertinimas") {
            const darbuotojoAtsakymai = atsakymai.filter(a => a.attributes.kasPildo === 'Darbuotojo forma');
            const imonesAtsakymai = atsakymai.filter(a => a.attributes.kasPildo === 'Įmonės forma');
            
            const darbuotojoRez = this.skaiciuotiFormosBendra(darbuotojoAtsakymai, tipai);
            const imonesRez = this.skaiciuotiFormosBendra(imonesAtsakymai, tipai);

            if (typeof darbuotojoRez === 'number' && !isNaN(darbuotojoRez) && 
                typeof imonesRez === 'number' && !isNaN(imonesRez)) {
                return (darbuotojoRez + imonesRez) / 2;
            }
            return '';
        }

        return this.skaiciuotiFormosBendra(atsakymai, tipai);
    }

    skaiciuotiFormosBendra(atsakymai, tipai) {
        const visiAtsakymaiPagalDatairImone = this.visiAtsakymaiPagalImonesIrDatas(atsakymai);
        let totalSum = 0;
        let totalCount = 0;

        Object.entries(visiAtsakymaiPagalDatairImone).forEach(([year, mapDatom]) => {
            const klausimynas = this.klausimynas(tipai, year);
            
            Object.values(mapDatom).forEach(mapImonem => {
                Object.values(mapImonem).forEach(imone => {
                    const imonesAtsakymai = this.imonesAtsakymai(imone, klausimynas, year);
                    
                    
                    Object.entries(imonesAtsakymai).forEach(([klausimas, balas]) => {
                        // Skip excluded questions and non-numeric values
                        if (this.isQuestionExcludedForYear(klausimas, year) || balas === '-' || !balas) {
                            return;
                        }
                        
                        if (typeof balas === 'number' && !isNaN(balas)) {
                            totalSum += balas;
                            totalCount++;
                        }
                    });
                });
            });
        });


        return totalCount > 0 ? totalSum / totalCount : '';
    }

    visiAts(tipai = [], info = []) {
        const x = {};
        const metais = this.datomAtsakymai(info);
        if (tipai.length > 0) {
            Object.entries(metais).forEach(([year, yearData]) => {
                tipai.forEach((e) => {
                    const filtruotaInfo = yearData.filter(f => f.attributes.kasPildo === e.attributes.kasPildo);
                    
                    if (filtruotaInfo.length > 0) {
                        const atsakymas = this.bendrasAtsakymas(filtruotaInfo, [e]);
                        if (atsakymas !== '' && typeof atsakymas === 'number' && !isNaN(atsakymas)) {
                            if (!x[year]) {
                                x[year] = {};
                            }
                            x[year][e.attributes.kasPildo] = atsakymas;
                        }
                    }
                });
            });
        }
        return x;
    }

    klausimuAtsakymai(atsakymai, tipai) {
        const visi = this.visiAtsakymaiPagalImonesIrDatas(atsakymai);
        const bendri = {};

        Object.keys(visi).forEach(mapDatom => {
            const klausimynas = this.klausimynas(tipai, mapDatom);
            
            Object.keys(visi[mapDatom]).forEach((mapImonem) => {
                const imonesIviena = [];
                Object.keys(visi[mapDatom][mapImonem]).forEach((imoneats => {
                    const imonesAtsakymai = this.imonesAtsakymai(visi[mapDatom][mapImonem][imoneats], klausimynas, mapDatom);
                    imonesIviena.push(imonesAtsakymai);
                }));
                bendri[mapImonem] = this.visuImoniuAtsakymaiIBendra(imonesIviena);
            });
        });

        return bendri;
    }
}
